import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eb132ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "display-flex ion-justify-content-center" }
const _hoisted_2 = { class: "display-flex ion-justify-content-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "spaced repetition", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "flashcard", -1))
const _hoisted_5 = { class: "display-flex ion-justify-content-center" }
const _hoisted_6 = { class: "display-flex ion-justify-content-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "word guessing game", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thinking_icon = _resolveComponent("thinking-icon")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_box_icon = _resolveComponent("box-icon")!
  const _component_join_us_icon = _resolveComponent("join-us-icon")!
  const _component_fun_icon = _resolveComponent("fun-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentIndex === 0)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 0,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_thinking_icon, {
                "fill-color-variable": '--ion-color-primary',
                "stroke-color-variable": '--ion-color-primary',
                class: "icon-container"
              })
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [
                _createTextVNode(" Ever wonder why you still remember the meaning of the words you learned in your childhood but struggle with a vocab learned a few days or weeks back? ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.currentIndex === 1)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 1,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_box_icon, {
                "fill-color-variable": '--ion-color-primary',
                "stroke-color-variable": '--ion-color-primary',
                class: "icon-container"
              })
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [
                _createTextVNode(" According to science, "),
                _hoisted_3,
                _createTextVNode(" is one of the techniques to retain anything in the long term. The Leitner system works based on this principle. It suggests creating a "),
                _hoisted_4,
                _createTextVNode(" for each item and reviewing those at an interval. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.currentIndex === 2)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 2,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_join_us_icon, {
                "fill-color-variable": '--ion-color-primary',
                "stroke-color-variable": '--ion-color-primary',
                class: "icon-container"
              })
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [
                _createTextVNode(" Join us to embed newly introduced words in your long-term memory. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.currentIndex === 3)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 3,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_fun_icon, {
                "fill-color-variable": '--ion-color-primary',
                "stroke-color-variable": '--ion-color-primary',
                class: "icon-container"
              })
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [
                _createTextVNode(" To make your learning experience more enjoyable and effective, try our "),
                _hoisted_7,
                _createTextVNode(". This fun and engaging activity challenges you to think critically and make connections between words and their meanings, enhancing your cognitive abilities while reinforcing what you've learned through spaced repetition. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}